import { render, staticRenderFns } from "./frontend-health.vue?vue&type=template&id=63047e92"
import script from "./frontend-health.vue?vue&type=script&lang=js"
export * from "./frontend-health.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports